/**
 * Collection of HTTP headers and their Documentation URLs
 */
export const httpHeaders = {
    accept: {
        name: 'Accept',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept',
    },
    'accept-ch': {
        name: 'Accept-CH',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept-CH',
    },
    'accept-ch-lifetime': {
        name: 'Accept-CH-Lifetime',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept-CH-Lifetime',
    },
    'accept-charset': {
        name: 'Accept-Charset',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept-Charset',
    },
    'accept-encoding': {
        name: 'Accept-Encoding',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept-Encoding',
    },
    'accept-language': {
        name: 'Accept-Language',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept-Language',
    },
    'accept-patch': {
        name: 'Accept-Patch',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept-Patch',
    },
    'accept-post': {
        name: 'Accept-Post',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept-Post',
    },
    'accept-ranges': {
        name: 'Accept-Ranges',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept-Ranges',
    },
    'access-control-allow-credentials': {
        name: 'Access-Control-Allow-Credentials',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Access-Control-Allow-Credentials',
    },
    'access-control-allow-headers': {
        name: 'Access-Control-Allow-Headers',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Access-Control-Allow-Headers',
    },
    'access-control-allow-methods': {
        name: 'Access-Control-Allow-Methods',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Access-Control-Allow-Methods',
    },
    'access-control-allow-origin': {
        name: 'Access-Control-Allow-Origin',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Access-Control-Allow-Origin',
    },
    'access-control-expose-headers': {
        name: 'Access-Control-Expose-Headers',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Access-Control-Expose-Headers',
    },
    'access-control-max-age': {
        name: 'Access-Control-Max-Age',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Access-Control-Max-Age',
    },
    'access-control-request-headers': {
        name: 'Access-Control-Request-Headers',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Access-Control-Request-Headers',
    },
    'access-control-request-method': {
        name: 'Access-Control-Request-Method',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Access-Control-Request-Method',
    },
    age: {
        name: 'Age',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Age',
    },
    allow: {
        name: 'Allow',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Allow',
    },
    'alt-svc': {
        name: 'Alt-Svc',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Alt-Svc',
    },
    'alt-used': {
        name: 'Alt-Used',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Alt-Used',
    },
    authorization: {
        name: 'Authorization',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Authorization',
    },
    'cache-control': {
        name: 'Cache-Control',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Cache-Control',
    },
    'clear-site-data': {
        name: 'Clear-Site-Data',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Clear-Site-Data',
    },
    connection: {
        name: 'Connection',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Connection',
    },
    'content-disposition': {
        name: 'Content-Disposition',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Disposition',
    },
    'content-dpr': {
        name: 'Content-DPR',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-DPR',
    },
    'content-encoding': {
        name: 'Content-Encoding',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Encoding',
    },
    'content-language': {
        name: 'Content-Language',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Language',
    },
    'content-length': {
        name: 'Content-Length',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Length',
    },
    'content-location': {
        name: 'Content-Location',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Location',
    },
    'content-range': {
        name: 'Content-Range',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Range',
    },
    'content-security-policy': {
        name: 'Content-Security-Policy',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy',
    },
    'content-security-policy-report-only': {
        name: 'Content-Security-Policy-Report-Only',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy-Report-Only',
    },
    'content-type': {
        name: 'Content-Type',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Type',
    },
    cookie: {
        name: 'Cookie',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Cookie',
    },
    'critical-ch': {
        name: 'Critical-CH',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Critical-CH',
    },
    'cross-origin-embedder-policy': {
        name: 'Cross-Origin-Embedder-Policy',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Cross-Origin-Embedder-Policy',
    },
    'cross-origin-opener-policy': {
        name: 'Cross-Origin-Opener-Policy',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Cross-Origin-Opener-Policy',
    },
    'cross-origin-resource-policy': {
        name: 'Cross-Origin-Resource-Policy',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Cross-Origin-Resource-Policy',
    },
    date: {
        name: 'Date',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Date',
    },
    'device-memory': {
        name: 'Device-Memory',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Device-Memory',
    },
    digest: {
        name: 'Digest',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Digest',
    },
    dnt: {
        name: 'DNT',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/DNT',
    },
    downlink: {
        name: 'Downlink',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Downlink',
    },
    dpr: {
        name: 'DPR',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/DPR',
    },
    'early-data': {
        name: 'Early-Data',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Early-Data',
    },
    ect: {
        name: 'ECT',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/ECT',
    },
    etag: {
        name: 'ETag',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/ETag',
    },
    expect: {
        name: 'Expect',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Expect',
    },
    'expect-ct': {
        name: 'Expect-CT',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Expect-CT',
    },
    expires: {
        name: 'Expires',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Expires',
    },
    forwarded: {
        name: 'Forwarded',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Forwarded',
    },
    from: {
        name: 'From',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/From',
    },
    host: {
        name: 'Host',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Host',
    },
    'if-match': {
        name: 'If-Match',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/If-Match',
    },
    'if-modified-since': {
        name: 'If-Modified-Since',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/If-Modified-Since',
    },
    'if-none-match': {
        name: 'If-None-Match',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/If-None-Match',
    },
    'if-range': {
        name: 'If-Range',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/If-Range',
    },
    'if-unmodified-since': {
        name: 'If-Unmodified-Since',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/If-Unmodified-Since',
    },
    'keep-alive': {
        name: 'Keep-Alive',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Keep-Alive',
    },
    'large-allocation': {
        name: 'Large-Allocation',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Large-Allocation',
    },
    'last-modified': {
        name: 'Last-Modified',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Last-Modified',
    },
    link: {
        name: 'Link',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Link',
    },
    location: {
        name: 'Location',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location',
    },
    'max-forwards': {
        name: 'Max-Forwards',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Max-Forwards',
    },
    nel: {
        name: 'NEL',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/NEL',
    },
    origin: {
        name: 'Origin',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Origin',
    },
    'permissions-policy': {
        name: 'Permissions-Policy',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Permissions-Policy',
    },
    pragma: {
        name: 'Pragma',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Pragma',
    },
    'proxy-authenticate': {
        name: 'Proxy-Authenticate',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Proxy-Authenticate',
    },
    'proxy-authorization': {
        name: 'Proxy-Authorization',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Proxy-Authorization',
    },
    range: {
        name: 'Range',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Range',
    },
    referer: {
        name: 'Referer',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Referer',
    },
    'referrer-policy': {
        name: 'Referrer-Policy',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Referrer-Policy',
    },
    'retry-after': {
        name: 'Retry-After',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After',
    },
    rtt: {
        name: 'RTT',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/RTT',
    },
    'save-data': {
        name: 'Save-Data',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Save-Data',
    },
    'sec-ch-prefers-reduced-motion': {
        name: 'Sec-CH-Prefers-Reduced-Motion',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-CH-Prefers-Reduced-Motion',
    },
    'sec-ch-prefers-reduced-transparency': {
        name: 'Sec-CH-Prefers-Reduced-Transparency',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-CH-Prefers-Reduced-Transparency',
    },
    'sec-ch-ua': {
        name: 'Sec-CH-UA',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-CH-UA',
    },
    'sec-ch-ua-arch': {
        name: 'Sec-CH-UA-Arch',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-CH-UA-Arch',
    },
    'sec-ch-ua-bitness': {
        name: 'Sec-CH-UA-Bitness',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-CH-UA-Bitness',
    },
    'sec-ch-ua-full-version': {
        name: 'Sec-CH-UA-Full-Version',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-CH-UA-Full-Version',
    },
    'sec-ch-ua-full-version-list': {
        name: 'Sec-CH-UA-Full-Version-List',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-CH-UA-Full-Version-List',
    },
    'sec-ch-ua-mobile': {
        name: 'Sec-CH-UA-Mobile',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-CH-UA-Mobile',
    },
    'sec-ch-ua-model': {
        name: 'Sec-CH-UA-Model',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-CH-UA-Model',
    },
    'sec-ch-ua-platform': {
        name: 'Sec-CH-UA-Platform',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-CH-UA-Platform',
    },
    'sec-ch-ua-platform-version': {
        name: 'Sec-CH-UA-Platform-Version',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-CH-UA-Platform-Version',
    },
    'sec-fetch-dest': {
        name: 'Sec-Fetch-Dest',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-Fetch-Dest',
    },
    'sec-fetch-mode': {
        name: 'Sec-Fetch-Mode',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-Fetch-Mode',
    },
    'sec-fetch-site': {
        name: 'Sec-Fetch-Site',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-Fetch-Site',
    },
    'sec-fetch-user': {
        name: 'Sec-Fetch-User',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-Fetch-User',
    },
    'sec-gpc': {
        name: 'Sec-GPC',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-GPC',
    },
    'sec-purpose': {
        name: 'Sec-Purpose',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-Purpose',
    },
    'sec-websocket-accept': {
        name: 'Sec-WebSocket-Accept',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Sec-WebSocket-Accept',
    },
    server: {
        name: 'Server',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Server',
    },
    'server-timing': {
        name: 'Server-Timing',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Server-Timing',
    },
    'service-worker-navigation-preload': {
        name: 'Service-Worker-Navigation-Preload',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Service-Worker-Navigation-Preload',
    },
    'set-cookie': {
        name: 'Set-Cookie',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie',
    },
    sourcemap: {
        name: 'SourceMap',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/SourceMap',
    },
    'strict-transport-security': {
        name: 'Strict-Transport-Security',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Strict-Transport-Security',
    },
    te: {
        name: 'TE',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/TE',
    },
    'timing-allow-origin': {
        name: 'Timing-Allow-Origin',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Timing-Allow-Origin',
    },
    tk: {
        name: 'Tk',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Tk',
    },
    trailer: {
        name: 'Trailer',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Trailer',
    },
    'transfer-encoding': {
        name: 'Transfer-Encoding',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Transfer-Encoding',
    },
    upgrade: {
        name: 'Upgrade',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Upgrade',
    },
    'upgrade-insecure-requests': {
        name: 'Upgrade-Insecure-Requests',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Upgrade-Insecure-Requests',
    },
    'user-agent': {
        name: 'User-Agent',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/User-Agent',
    },
    vary: {
        name: 'Vary',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Vary',
    },
    via: {
        name: 'Via',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Via',
    },
    'viewport-width': {
        name: 'Viewport-Width',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Viewport-Width',
    },
    'want-digest': {
        name: 'Want-Digest',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Want-Digest',
    },
    warning: {
        name: 'Warning',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Warning',
    },
    width: {
        name: 'Width',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Width',
    },
    'www-authenticate': {
        name: 'WWW-Authenticate',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/WWW-Authenticate',
    },
    'x-content-type-options': {
        name: 'X-Content-Type-Options',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/X-Content-Type-Options',
    },
    'x-dns-prefetch-control': {
        name: 'X-DNS-Prefetch-Control',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/X-DNS-Prefetch-Control',
    },
    'x-forwarded-for': {
        name: 'X-Forwarded-For',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/X-Forwarded-For',
    },
    'x-forwarded-host': {
        name: 'X-Forwarded-Host',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/X-Forwarded-Host',
    },
    'x-forwarded-proto': {
        name: 'X-Forwarded-Proto',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/X-Forwarded-Proto',
    },
    'x-frame-options': {
        name: 'X-Frame-Options',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/X-Frame-Options',
    },
    'x-xss-protection': {
        name: 'X-XSS-Protection',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/X-XSS-Protection',
    },
    'cf-cache-status': {
        name: 'Cf-Cache-Status',
        url: 'https://developers.cloudflare.com/cache/concepts/default-cache-behavior/#cloudflare-cache-responses',
    },
    'cf-ray': {
        name: 'Cf-Ray',
        url: 'https://developers.cloudflare.com/fundamentals/get-started/reference/http-request-headers/#cf-ray',
    },
    'report-to': {
        name: 'Report-To',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/report-to',
    },
    'x-cloud-trace-context': {
        name: 'X-Cloud-Trace-Context',
        url: 'https://cloud.google.com/trace/docs/trace-context#legacy-http-header',
    },
    'speculation-rules': {
        name: 'Speculation-Rules',
        url: 'https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Speculation-Rules',
    },
};
